export const FETCH_VIN_LOOKUP = "FETCH_VIN_LOOKUP";
export const FETCH_VIN_LOOKUP_SUCCESS = "FETCH_VIN_LOOKUP_SUCCESS";
export const FETCH_VIN_LOOKUP_FAILED = "FETCH_VIN_LOOKUP_FAILED";

export const CHANGE_OWNERSHIP_TRANSFER = "CHANGE_OWNERSHIP_TRANSFER";
export const CHANGE_OWNERSHIP_TRANSFER_SUCCESS =
  "CHANGE_OWNERSHIP_TRANSFER_SUCCESS";
export const CHANGE_OWNERSHIP_TRANSFER_FAILED =
  "CHANGE_OWNERSHIP_TRANSFER_FAILED";

export const FETCH_ALL_USERS = "FETCH_ALL_USERS";
export const FETCH_ALL_USERS_SUCCESS = "FETCH_ALL_USERS_SUCCESS";
export const FETCH_ALL_USERS_FAILED = "FETCH_ALL_USERS_FAILED";

export const FETCH_TRANSFER_MODERATION_LISTING =
  "FETCH_TRANSFER_MODERATION_LISTING";
export const FETCH_TRANSFER_MODERATION_LISTING_SUCCESS =
  "FETCH_TRANSFER_MODERATION_LISTING_SUCCESS";
export const FETCH_TRANSFER_MODERATION_LISTING_FAILED =
  "FETCH_TRANSFER_MODERATION_LISTING_FAILED";

export const FETCH_TRANSFER_MODERATION_DETAIL_LISTING =
  "FETCH_TRANSFER_MODERATION_DETAIL_LISTING";
export const FETCH_TRANSFER_MODERATION_DETAIL_LISTING_SUCCESS =
  "FETCH_TRANSFER_MODERATION_DETAIL_LISTING_SUCCESS";
export const FETCH_TRANSFER_MODERATION_DETAIL_LISTING_FAILED =
  "FETCH_TRANSFER_MODERATION_DETAIL_LISTING_FAILED";

export const TRANSFER_MODERATION = "TRANSFER_MODERATION";
export const TRANSFER_MODERATION_SUCCESS = "TRANSFER_MODERATION_SUCCESS";
export const TRANSFER_MODERATION_FAILED = "TRANSFER_MODERATION_FAILED";

export const UPLOAD_URL = "UPLOAD_URL";
export const UPLOAD_URL_SUCCESS = "UPLOAD_URL_SUCCESS";
export const UPLOAD_URL_FAILED = "UPLOAD_URL_FAILED";

export const READ_URL = "READ_URL";
export const READ_URL_SUCCESS = "READ_URL_SUCCESS";
export const READ_URL_FAILED = "READ_URL_FAILED";

export const UPLOAD_BINARY_URL = "UPLOAD_BINARY_URL";
export const UPLOAD_BINARY_URL_SUCCESS = "UPLOAD_BINARY_URL_SUCCESS";
export const UPLOAD_BINARY_URL_FAILED = "UPLOAD_BINARY_URL_FAILED";

export const CLEAR_REDUCER_VIN_LOOKUP = "CLEAR_REDUCER_VIN_LOOKUP";
